import React, { createContext, useContext } from 'react';

import type { ProfilecardTriggerPosition } from '@atlaskit/profilecard/types';

type ReportingLinesContextType = {
	product?: string;
	WrappedWithProfilecard?: React.ComponentType<{
		children: React.ReactElement;
		userId: string;
		position?: ProfilecardTriggerPosition;
	}>;
	/**
	 * Optional attributes to merge into the ReportingLinesChart.viewed event (e.g. tab, isNewUserProfile for user profile)
	 */
	viewedEventAttributes?: Record<string, string | boolean>;
	selectedCardRef?: React.RefObject<HTMLDivElement>;
};

const ReportingLinesContext = createContext<ReportingLinesContextType>({});

export const ReportingLinesProvider = ({
	children,
	product,
	WrappedWithProfilecard,
	viewedEventAttributes,
	selectedCardRef,
}: ReportingLinesContextType & { children: React.ReactElement }): React.JSX.Element => {
	return (
		<ReportingLinesContext.Provider
			value={{ product, WrappedWithProfilecard, viewedEventAttributes, selectedCardRef }}
		>
			{children}
		</ReportingLinesContext.Provider>
	);
};

export const useReportingLinesContext = () => useContext(ReportingLinesContext);
